import { createAction } from 'redux-actions';

export const requestGetUnrealizedPotential = createAction('REQUEST_GET_UNREALIZED_POTENTIAL');
export const receiveGetUnrealizedPotential = createAction('RECEIVE_GET_UNREALIZED_POTENTIAL');
export const requestGetUnrealizedPotentialArguments = createAction('REQUEST_GET_UNREALIZED_POTENTIAL_ARGUMENTS');
export const receiveGetUnrealizedPotentialArguments = createAction('RECEIVE_GET_UNREALIZED_POTENTIAL_ARGUMENTS');
